import { Environment } from '@abp/ng.core';

const baseUrl = 'https://demo.healthmax.co.nz/';

const oAuthConfig = {
	issuer: 'https://app-healthmax-apix-integration.azurewebsites.net/',
	tokenEndpoint: 'https://app-healthmax-apix-integration.azurewebsites.net/connect/token',
	redirectUri: baseUrl,
	clientId: 'HealthMax_Pwa',
	responseType: 'code',
	scope: 'offline_access Pharmist',
	requireHttps: true,
	postLogoutRedirectUri: 'https://demo.healthmax.co.nz/splash',
	useRefreshToken: true,
};

export const environment = {
	tenant: 'hm-bargainchemist',
	production: false,
	brand: 'bargainchemist',
	application: {
		baseUrl,
		name: 'Bargain Chemist',
	},
	oAuthConfig,
	apis: {
		default: {
			url: 'https://app-healthmax-apix-integration.azurewebsites.net',
			rootNamespace: 'HealthMax',
		}
	},
	testUsername: '',
	testPassword: '',
	shopify: {
		domain: 'bargain-chemist-staging-store.myshopify.com',
		publicAccessToken: '6c41d8082ee229640c7695cbbaa2d37c',
		apiVersion: '2023-10',
		referralCode: 'healthmax-bc',
		handleCollectionHome: 'healthmax-home',
		handleCollectionShop: 'healthmax-shop',
		handleProductDelivery: 'healthmax-delivery',
	},
	shopifyStaging: {
		domain: 'bargain-chemist-staging-store.myshopify.com',
		publicAccessToken: '6c41d8082ee229640c7695cbbaa2d37c',
		apiVersion: '2023-10',
		referralCode: 'healthmax-bc',
		handleCollectionHome: 'healthmax-home',
		handleCollectionShop: 'healthmax-shop',
		handleProductDelivery: 'healthmax-delivery',
	},
	privacyPolicyUrl: 'https://www.bargainchemist.co.nz/policies/privacy-policy',
	termsUrl: 'https://www.bargainchemist.co.nz/policies/terms-of-service',
	defaultCustomerEmailDomain: 'customers.healthmax.co.nz'
} as Environment;
